// src/config.js
const getBaseUrl = () => {
    const hostname = window.location.hostname;
  
    // Check if running locally
    if (hostname === 'localhost') {
      return 'http://localhost:6124';
    }
  
    // If running on the server
    return 'https://apiviztech.in:6124';
  };
  
  const BASE_URL = getBaseUrl();
  
  export default BASE_URL;